const NotifyComponent = ({ data }) => {
  return (
    <div className="msg-container">
      {data?.title && <p className="text-md">{data?.title}</p>}
      {data?.text && <p className="text-xs">{data?.text}</p>}
      {data?.customMsg && <p className="text-xs">{data?.customMsg}</p>}
    </div>
  );
};

export default NotifyComponent;
